import { Injectable } from '@angular/core';

import { ToastClass, ToasterFacade, ToastType } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class ToastDeprecatedService {
  constructor(private readonly toasterFacade: ToasterFacade) {}

  /**
   * Adds toast with given message.
   * @param {string} message the message to display in the toast.
   * @param {ToastType} type
   * @param {ToastClass} toastClass the toast category
   * @param {number} [duration] if set, the toast will be closed automatically when duration ellapsed.
   * @param {number} [translate] set if the message need to be translated or not.
   * @param {string} [from] to set an author name displayed before message
   * @param {IContact} [acceptContact] set if acceptContact need to be shown
   * @returns {IToast} an IToast instance representing the added toast.
   */
  add(
    type: ToastType,
    message: string,
    cssClass?: ToastClass,
    duration?: number,
    author?: string,
    contactId?: string,
    title?: string
  ): void {
    this.toasterFacade.add({
      componentName: type,
      cssClass,
      message,
      author,
      duration,
      data: contactId,
      title,
    });
  }

  /**
   * Add a notification toast.
   * @param {string} message the message to display.
   * @param {number} [duration] if set, the toast will be closed automatically when duration ellapsed.
   * @returns {IToast} an IToast instance representing the added toast.
   */
  notify(message: string, duration?: number): void {
    this.add(ToastType.NOTIFICATION, message, undefined, duration);
  }

  /**
   * Add an alert toast.
   * @param {string} message the message to display.
   * @returns {IToast} an IToast instance representing the added toast.
   */
  alert(message: string, duration?: number, title?: string): void {
    this.add(ToastType.ALERT, message, undefined, duration, undefined, undefined, title);
  }
}
